/// <reference path="../app.ts" />
namespace Cfnc {
    "use strict";

    interface ITranscriptActivityModalScope extends ng.IScope {
        close;
        openTranscript: (transcriptId) => void;
        cancelRequest: (transactionId) => void;
        confirmCancel: (confirm) => void;
        canCancel: (dateRequested: Date) => boolean;
        transcriptStatus: Array<ITranscriptStatus>;
        firstName: string;
        lastName: string;
        studentId: string;
        organizationName: string;
    }

    interface ITranscriptActivityModal {

    }

    interface ITranscriptStatus {
        transactionId: number;
        dateCompleted?: Date;
        dateOfLastAttempt?: Date;
        dateRequested: Date;
        releaseDate?: Date;
        inProgress: boolean;
        transcriptType: string;
        status: string;
        applicationId: string;
        transcriptId: number;
        userStartedApp: boolean;
        busy: boolean;
        hasBeenExported: boolean;
        cancelBusy: boolean;
    }

    class TranscriptActivityModal implements ITranscriptActivityModal {
        static controllerId: string = "transcriptActivityModal";
        private log;
        logError: (msg, data?, showToast?) => void;
        logSuccess: (msg, data?, showToast?) => void;
        constructor(private $uibModal: ng.ui.bootstrap.IModalService,
            private $uibModalInstance: ng.ui.bootstrap.IModalServiceInstance,
            private common: ICommonFactory,
            private $scope: ITranscriptActivityModalScope,
            private $resource: ng.resource.IResourceService, data: any,
            private Restangular: Restangular.IService) {
            this.log = common.logger.getLogFn(TranscriptActivityModal.controllerId);
            this.logError = common.logger.getLogFn(TranscriptActivityModal.controllerId, "error");
            this.logSuccess = common.logger.getLogFn(TranscriptActivityModal.controllerId, "success");
            $scope.close = () => this.close();
            $scope.openTranscript = (transcriptId) => this.openTranscript(transcriptId);
            $scope.cancelRequest = (transactionId) => this.cancelRequest(transactionId);
            $scope.confirmCancel = (confirm) => this.confirmCancel(confirm);
            $scope.canCancel = (dateRequested) => this.canCancel(dateRequested);

            if (data) {
                $scope.transcriptStatus = data.transcriptStatus;
                $scope.firstName = data.firstName;
                $scope.lastName = data.lastName;
                $scope.studentId = data.studentId;
                $scope.organizationName = data.organizationName;
            }

        }

        close() {
            this.$uibModalInstance.dismiss();

        }

        openTranscript(transcriptId) {
            var transcript = _.find<ITranscriptStatus>(this.$scope.transcriptStatus, { transcriptId: transcriptId });
            transcript.busy = true;
            this.Restangular.all("application").one("transcript", transcriptId).get().then(
                (result) => {
                    var transcriptWindow: any = window.open("/app/apphub/viewtranscript.html", "", "menubar=no, toolbar=no, width=800, height=600, scrollbars=yes, resizable=yes");
                    transcriptWindow.onload = function () { transcriptWindow.document.getElementById("transcriptContainer").innerHTML = result; };
                    transcriptWindow.focus();
                    transcript.busy = false;
                },
                (reason) => {
                    this.logError("There was an error getting the transcript.", reason, true);
                    transcript.busy = false;
                });

        }

        canCancel(releaseDate: Date): boolean {
            return moment(releaseDate).isAfter(moment().add(2, "days"));
        }

        cancelRequest(transactionId) {
            var transaction = _.find<ITranscriptStatus>(this.$scope.transcriptStatus, { transactionId: transactionId });
            if (transaction.status != "Pending" || transaction.transcriptType != "Final" || !this.canCancel(transaction.releaseDate)) {
                this.logError("Transcript request can not be cancelled at this time.", null, true);
                return;
            }

            transaction.cancelBusy = true;

            var modalInstance = this.$uibModal.open({
                templateUrl: '/app/apphub/confirmCancelTranscript.html',
                controller: 'transcriptActivityModal',
                resolve: {
                    data: function () { return null }
                }
            });

            modalInstance.result.then((val: boolean) => {
                if (val === true) {
                    this.Restangular.one("transcripts", transactionId).one("cancel").put()
                        .then((response) => {
                            var transaction = _.find<ITranscriptStatus>(this.$scope.transcriptStatus, { transactionId: transactionId });
                            transaction.status = "Canceled";

                            this.logSuccess("Transcript request cancelled");
                        },
                        (reason) => {
                            this.logError("An error occurred while canceling the request.", reason, true);
                        }

                        ).finally(() => {
                            transaction.cancelBusy = false;
                        })

                } else {
                    transaction.cancelBusy = false;
                }
            });
        }

        confirmCancel(confirm: boolean) {
            this.$uibModalInstance.close(confirm);

        }
        
    }
    angular.module("app").controller(TranscriptActivityModal.controllerId,
        ["$uibModal", "$uibModalInstance", "common", "$scope", "$resource", "data", "Restangular",
            ($uibModal: ng.ui.bootstrap.IModalService,
                $uibModalInstance: ng.ui.bootstrap.IModalServiceInstance,
                common: ICommonFactory,
                $scope,
                $resource,
                data: ITranscriptStatus,
                Restangular: Restangular.IService) =>
                new TranscriptActivityModal($uibModal, $uibModalInstance, common, $scope, $resource, data, Restangular)
        ]);
}
